import PropTypes from 'prop-types';
import React from 'react';

const HourGlassIcon01 = ({
  width = 24,
  height = 24,
  fill = '#1B1B18'
}) => {
  return (
    <svg
      className="c-HourGlassIcon01"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={fill}
        fillRule="evenodd"
        d="M3 2a1 1 0 011-1h16a1 1 0 110 2h-1v1.867c0 .714 0 1.254-.137 1.767a4 4 0 01-.592 1.263c-.306.435-.72.78-1.27 1.237l-.088.073L13.562 12l3.351 2.793.089.073c.549.457.963.803 1.27 1.237a4 4 0 01.59 1.263c.139.513.138 1.053.138 1.767V21h1a1 1 0 110 2H4a1 1 0 110-2h1v-1.752-.115c0-.714 0-1.254.137-1.767a4 4 0 01.592-1.263c.306-.435.72-.78 1.27-1.237l.088-.073L10.438 12 7.087 9.207l-.089-.073c-.549-.457-.963-.802-1.27-1.237a4 4 0 01-.59-1.263C4.998 6.121 5 5.581 5 4.867V3H4a1 1 0 01-1-1zm4 1v1.752c0 .88.008 1.137.069 1.362a2 2 0 00.295.632c.135.19.327.361 1.003.925L12 10.698l3.633-3.027c.676-.564.868-.734 1.003-.925.134-.192.235-.405.295-.632.061-.225.069-.482.069-1.362V3H7zm5 10.302l-3.633 3.027c-.676.564-.868.734-1.003.925a2 2 0 00-.295.631c-.061.226-.069.483-.069 1.363V21h10v-1.752c0-.88-.008-1.137-.069-1.363-.06-.226-.16-.44-.295-.63-.135-.192-.327-.362-1.003-.926L12 13.302z"
        clipRule="evenodd"></path>
    </svg>
  );
};

HourGlassIcon01.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};

export default HourGlassIcon01;
